import React from 'react';
import {connect} from 'react-redux';
import TableRow from '../../../../../components/TableRow';
import {getTournamentStatusName} from '../../../../../../../helpers/tournament';
import moment from 'moment';
import TournamentUsers from '../../../TournamentUsers';
import {getEndpoint, getHeaders} from '../../../../../../../helpers/endpoint';
import {fetchTournamentIfNeeded} from '../../../../../../../actions/app/support/tournament';

const tournamentType = [
  {name: 'public', value: true},
  {name: 'private', value: false},
];

export const leagueMode = {
  1: 'Normal',
  2: 'Expert',
};

export const updateTournamentIsPublic = payload => {
  return (dispatch, getState) => {
    fetch(getEndpoint('updateTournamentIsPublic', payload.tournamentId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({isPublic: payload.isPublic}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchTournamentIfNeeded(payload.tournamentId));
        }
      });
  };
};

export const updateTournamentName = payload => {
  return (dispatch, getState) => {
    fetch(getEndpoint('updateTournamentName', payload.tournamentId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({name: payload.name}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchTournamentIfNeeded(payload.tournamentId));
        }
      });
  };
};

const TournamentInfos = ({
  entity,
  dispatch,
  tournamentUsers,
  name,
  handleNameChange,
  championship,
}) => {
  function copyToClipboard() {
    const text = document.createElement('textarea');
    text.value = entity.adminId;
    document.body.appendChild(text);
    text.select();
    document.execCommand('copy');
    document.body.removeChild(text);
  }

  moment.locale('fr');

  function getStringRoundName(currentRound, nbRounds, isPreliminaryRound) {
    const dif = nbRounds - currentRound;
    if (currentRound === 1 && isPreliminaryRound) {
      return 'Préliminaire';
    }
    if (dif === 0) {
      return 'Finale';
    }
    if (dif === 1) {
      return 'Demi';
    }
    if (dif === 2) {
      return 'Quart de finale';
    }
    if (dif === 3) {
      return '1/8 de finale';
    }
    if (dif === 4) {
      return '1/16 de finale';
    }
    if (dif === 5) {
      return '1/32 de finale';
    }
    return 'Tour ' + currentRound;
  }

  const championshipName = championship?.lang['fr-FR']?.shortName;

  return (
    <div>
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr style={{padding: 16}}>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <TableRow label="id" value={entity.id} />
          <TableRow label="Code Tournoi" value={entity.shortId} />
          <TableRow
            label="Nom"
            value={
              <input
                type="text"
                color={'black'}
                defaultValue={entity.name}
                onChange={handleNameChange}
              />
            }
            action={
              <input
                type="submit"
                value="Valider"
                onClick={() =>
                  dispatch(
                    updateTournamentName({
                      tournamentId: entity.id,
                      name: name,
                    }),
                  )
                }
              />
            }
          />
          <TableRow label="Championnat" value={championshipName} />
          <TableRow
            label="Status"
            value={getTournamentStatusName(entity.status)}
          />
          <TableRow
            label="Date de création"
            value={moment(entity.createdAt).format('DD/MM/YYYY')}
          />
          <TableRow
            label="Date de début de journée"
            value={
              'J' +
              entity?.gameSettings?.startingGameWeekNumber +
              ' - ' +
              moment(entity.startDate).format('DD MMM')
            }
          />
          <TableRow
            label="Nombre de users"
            value={tournamentUsers?.total || 0}
          />
          <TableRow
            label="Nombre de joueur max"
            value={entity.maxUsers || ' - '}
          />
          <TableRow
            label="Public or private"
            value={
              <select
                className="form-control"
                onChange={event =>
                  dispatch(
                    updateTournamentIsPublic({
                      tournamentId: entity.id,
                      isPublic: event.target.value,
                    }),
                  )
                }
                value={entity.isPublic}>
                {tournamentType.map(type => (
                  <option key={type.value} value={type.value}>
                    {type.name}
                  </option>
                ))}
              </select>
            }
          />
          <TableRow
            label="Créateur"
            value={<text>{entity.adminId}</text>}
            action={
              <input type="submit" value="Copier" onClick={copyToClipboard} />
            }
          />
          <TableRow
            label="Tour actuel"
            value={
              entity?.liveState?.currentRoundNumber &&
              entity?.gameSettings?.roundsQuantity
                ? getStringRoundName(
                    entity?.liveState?.currentRoundNumber,
                    entity?.gameSettings?.roundsQuantity,
                    entity?.isFirstRoundPreliminary,
                  )
                : ' - '
            }
          />
        </tbody>
      </table>
      {tournamentUsers && entity && (
        <TournamentUsers
          key={entity.id}
          users={tournamentUsers}
          tournamentInfos={entity}
        />
      )}
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(TournamentInfos);



// WEBPACK FOOTER //
// ./src/pages/Support/Tournament/Widgets/TournamentInfo/components/Infos/index.js